// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__IQ_7K","rootSmall":"AddTileButton_rootSmall__1w0_N"};